import Api from "../../../util/Api";
import LoginUtil from "../../../util/LoginUtil";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        formIsOpen: false,
        gridIsOpen: true,
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új felhasználó',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyRow',
                additionalButtonVisible: "hasRoleSeniorAssistantOrDoctorCoordinatorOrFeuAdminOrBackofficeManager"
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: "hasRoleSeniorAssistantOrDoctorCoordinatorOrFeuAdminOrBackofficeManager"
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                event_payload: 'unDeleteRow',
                additionalButtonVisible: "hasRoleSeniorAssistantOrDoctorCoordinatorOrFeuAdminSeeCaseOfDeletedW"
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "company.name",
                label: "Cég",
                formType: 'text',
                formSize: 3,
                formVisible: false
            },
            {
                name: "emailAddress",
                label: "E-mail cím",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'email',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "password",
                label: "Jelszó",
                description: "2FA és Külső felhasználó esetén kötelező!",
                formType: 'password',
                formSize: 3,
                formVisible: LoginUtil.isDevLoginType(),
                visibility: false
            },
            {
                name: "password_again",
                label: "Jelszó újra",
                description: "2FA és Külső felhasználó esetén kötelező!",
                formType: 'password',
                formSize: 3,
                formVisible: LoginUtil.isDevLoginType(),
                visibility:false
            },
            {
                name: "companyId",
                label: "Cég",
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllCompany,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                visibility: false,
                formVisible: true,
                formRequired: true
            },
            {
                name: "userTypeId",
                label: "Alkalmazott típus",
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getUserPersonTypeFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                visibility: false,
                formRequired: true,
                formVisible: true
            },
            {
                name: "firstName",
                label: "Keresztnév",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                formSize: 3,
                formVisible: true,
                formRequired: true,
            },
            {
                name: "lastName",
                label: "Vezetéknév",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'text',
                formSize: 3,
                visibility: true,
                formVisible: true,
                formRequired: true
            },
            {
                name: "phone",
                label: "Telefonszám",
                formType: 'tel',
                formSize: 3,
                visibility: true,
                formVisible: true
            },
            {
                name: "dateOfBirth",
                label: "Születési dátum",
                slot_name: "date_format",
                formType: 'date',
                formSize: 3,
                visibility: true,
                formVisible: true,
                formRequired: true
            },
            {
                name: "zipCode",
                label: "Irányítószám",
                formType: 'number',
                formSize: 3,
                visibility: true,
                formVisible: true,
                formRequired: true
            },
            {
                name: "city",
                label: "Település",
                formType: 'text',
                formSize: 3,
                visibility: true,
                formVisible: true,
                formRequired: true
            },
            {
                name: "eesztUsername",
                label: "EESZT felhasználónév",
                description: "O (orvos), S (egészségügyi dolgozó) és ENKK nyilvántartási számuk, pl: O12345",
                sort: true,
                formType: 'text',
                formSize: 3,
                visibility: false,
                formVisible: true
            },
            {
                name: "adUsername",
                label: "AD felhasználónév",
                sort: true,
                formType: 'text',
                formSize: 3,
                visibility: false,
                formVisible: LoginUtil.isADAzureLoginType(),
            },
            {
                name: "ojoteUsername",
                label: "OJOTE felhasználónév",
                sort: true,
                formType: 'text',
                formSize: 3,
                visibility: false,
                formVisible: true,
                formRequired: false
            },
            {
                name: "ojotePassword",
                label: " OJOTE jelszó",
                formType: 'password',
                formSize: 3,
                visibility: false,
                formVisible: true,
                formRequired: false
            },
            {
                name: "deleted",
                label: "Státusz",
                slot_name: "status_format",
                formType: 'text',
                formSize: 7,
                visibility: true,
                formVisible: false
            },
            {
                name: "isExternalUser",
                label: "Külső felhasználó",
                description: "Medici API-t használó felhasználó",
                formType: 'checkbox',
                formSize: 3,
                visibility: false,
                formVisible: true
            },
            {
                name: "isTwoFactorAuthenticationUser",
                label: "2FA felhasználó",
                description: "Külsős felhasználó, aki csak két faktoros autentikációval tud belépni (pl.: FEÜ menedzser)",
                formType: 'checkbox',
                formSize: 3,
                visibility: false,
                formVisible: LoginUtil.isDevLoginType()
            },
            {
                name: "companySiteId",
                label: "Ellátóhely",
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllCompanySite,
                    formatText: function (val) {
                        return val.siteName;
                    },
                    formatOption: function (val) {
                        return val.siteName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'siteName',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formRequired: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "roles",
                label: "Jogosultságok",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllRoleApiCallback,
                    formatOption: function (val) {
                        return val.role;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'role',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 12,
                visibility: false,
                formVisible: true
            },
            {
                name: "treatmentTypes",
                label: "Kezelések",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllTreatmentTypeForTreatments,
                    formatOption: function (val) {
                        return val.title;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'title',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 12,
                visibility: false,
                formVisible: true
            },
            {
                name: "organizationUnits",
                label: "Szervezeti egységek",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.findAllOrganizationUnitWithoutDeleted,
                    formatOption: function (val) {
                        return val.companyName
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'companyName',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 12,
                visibility: false,
                formVisible: true
            },
            {
                name: "occupationHealthPartners",
                label: "FEÜ partnerek",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllOccupationHealthPartners,
                    formatOption: function (val) {
                        return val.name;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'name',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 12,
                visibility: false,
                formVisible: true
            },
            {
                name: "companySites",
                label: "Ellátóhelyek",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getCompanySiteToCheckboxes,
                    additionalApiCallbackParams: {},
                    formatOption: function (val) {
                        return val.siteName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'siteName',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 12,
                visibility: false,
                formVisible: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ],
        feuPartnerManagerFields: [
            {
                name: "emailAddress",
                label: "E-mail cím",
                formType: 'email',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "password",
                label: "Jelszó",
                formType: 'password',
                formSize: 3,
                formVisible: LoginUtil.isDevLoginType(),
            },
            {
                name: "password_again",
                label: "Jelszó újra",
                formType: 'password',
                formSize: 3,
                formVisible: LoginUtil.isDevLoginType(),
            },
            {
                name: "firstName",
                label: "Keresztnév",
                formType: 'text',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "lastName",
                label: "Vezetéknév",
                formType: 'text',
                formSize: 3,
                visibility: true,
                formVisible: true,
                formRequired: true
            },
            {
                name: "phone",
                label: "Telefonszám",
                formType: 'tel',
                formSize: 3,
                visibility: true,
                formVisible: true
            },
            {
                name: "dateOfBirth",
                label: "Születési dátum",
                formType: 'date',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "zipCode",
                label: "Irányítószám",
                formType: 'number',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "city",
                label: "Település",
                formType: 'text',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "companySites",
                label: "Ellátóhelyek",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getCompanySiteToCheckboxes,
                    additionalApiCallbackParams: {},
                    formatOption: function (val) {
                        return val.siteName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'siteName',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 12,
                visibility: false,
                formVisible: true
            }
        ]
    }
}
